import { Typography } from '@mui/material';
import styled from 'styled-components';

export const AutocompleteOption = styled(Typography)`
  padding: 6px;
  &:first-letter {
    text-transform: capitalize;
  }
`;
